import React from 'react';
import ReactDOM from 'react-dom';
import App from './features/app'

import { Auth0Provider } from "./providers/auth0";
import config from "./auth_config.json";



const onRedirectCallback = appState => {
  window.history.replaceState(
    {},
    document.title,
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};

ReactDOM.render(<Auth0Provider
  domain={config.domain}
  client_id={config.clientId}
  redirect_uri={window.location.origin}
  onRedirectCallback={onRedirectCallback}
>
  <App />
</Auth0Provider>, document.getElementById('root'));
